import { render, staticRenderFns } from "./PatientAnalysis.vue?vue&type=template&id=2ac1b41a&scoped=true"
import script from "./PatientAnalysis.vue?vue&type=script&lang=js"
export * from "./PatientAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac1b41a",
  null
  
)

export default component.exports